import { Component, OnInit, inject } from '@angular/core';
import {
  ActivationEnd,
  ActivationStart,
  ChildActivationEnd,
  ChildActivationStart,
  GuardsCheckEnd,
  GuardsCheckStart,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  ResolveEnd,
  ResolveStart,
  Router,
  RouterOutlet,
  RoutesRecognized,
} from '@angular/router';
import { VersionWatcherService } from './core/services/version-watcher-service';
import { SearchHighlightService } from './core/services/search-highlight.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  readonly versionWatcher = inject(VersionWatcherService);
  readonly searchHighlight = inject(SearchHighlightService);
  readonly router = inject(Router);

  ngOnInit(): void {
    this.versionWatcher.init();
    this.searchHighlight.init();
    this.logRouterFlow();
  }

  private logRouterFlow(): void {
    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationStart ||
        event instanceof RoutesRecognized ||
        event instanceof GuardsCheckStart ||
        event instanceof GuardsCheckEnd ||
        event instanceof ResolveStart ||
        event instanceof ResolveEnd ||
        event instanceof ActivationStart ||
        event instanceof ActivationEnd ||
        event instanceof ChildActivationStart ||
        event instanceof ChildActivationEnd ||
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
      }

      if (event instanceof NavigationEnd) {
        this.dumpRouteTree(this.router.routerState.snapshot.root);
      }

      if (event instanceof NavigationCancel) {
        console.warn('[RouterEvent] NavigationCancel reason =', event.reason);
      }

      if (event instanceof NavigationError) {
        console.error('[RouterEvent] NavigationError error =', event.error);
      }
    });
  }

  private describeEvent(event: any): any {
    const snapshot = event.snapshot ?? event.state?.root;

    return {
      url: event.url ?? event.urlAfterRedirects ?? this.router.url,
      routePath: snapshot?.routeConfig?.path ?? '(none)',
      component: snapshot?.routeConfig?.component?.name ?? '(none)',
      data: snapshot?.routeConfig?.data ?? snapshot?.data ?? null,
    };
  }

  private dumpRouteTree(node: any, depth = 0): void {
    const indent = '  '.repeat(depth);

    node.children?.forEach((child: any) => this.dumpRouteTree(child, depth + 1));
  }
}
